import { OuiValidationError } from 'omnium-ui/form-field';

export function dateValiditePjErrors(): OuiValidationError[] {
  return [
    {
      code: 'finBeforeDebut',
      message: 'La date de fin doit être aprés la date de début',
    },
    {
      code: 'afterToday',
      message: 'La date doit être inférieure ou égale à la date du jour',
    },
    {
      code: 'dejaValidee',
      message: 'Un document validé existe déjà avec cette date de début de validité',
    },
  ];
}
